(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anime-product"]) return;
  try {
    
document.addEventListener('change', (event) => {
  const radio = event.target;
  if (!radio.matches('[data-site9-product] input[name="id"]')) return;
  const root = radio.closest('[data-site9-product]');
  root.querySelector('[data-site9-current-price]').textContent = radio.dataset.site9Price;
  const was = root.querySelector('[data-site9-was]');
  const saving = root.querySelector('[data-site9-saving]');
  was.textContent = radio.dataset.site9Was;
  saving.textContent = radio.dataset.site9Saving;
  was.hidden = radio.dataset.site9Sale !== 'true';
  saving.hidden = radio.dataset.site9Sale !== 'true';
  const button = root.querySelector('[data-site9-add]');
  button.disabled = radio.dataset.site9Available !== 'true';
  root.querySelector('[data-site9-add-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.availableLabel;
  root.querySelector('[data-site9-sticky-price]').textContent = radio.dataset.site9Price;
  root.querySelector('[data-site9-sticky-model]').textContent = radio.nextElementSibling.textContent;
  root.querySelector('[data-site9-sticky-add]').disabled = button.disabled;
  root.querySelector('[data-site9-sticky-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.availableLabel;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', radio.value);
  window.history.replaceState({}, '', url);
});
document.addEventListener('click', (event) => {
  const step = event.target.closest('[data-site9-gallery-step]');
  if (step) {
    const root = step.closest('[data-site9-product]');
    const thumbs = [...root.querySelectorAll('[data-site9-image]')];
    const current = thumbs.findIndex((thumb) => thumb.getAttribute('aria-pressed') === 'true');
    if (thumbs.length > 1) thumbs[(current + Number(step.dataset.site9GalleryStep) + thumbs.length) % thumbs.length].click();
    return;
  }
  const thumb = event.target.closest('[data-site9-image]');
  if (!thumb) return;
  const root = thumb.closest('[data-site9-product]');
  const image = root.querySelector('.site9-gallery-image');
  image.removeAttribute('srcset');
  image.src = thumb.dataset.site9Image;
  const counter = root.querySelector('[data-site9-photo-index]');
  if (counter) counter.textContent = [...root.querySelectorAll('[data-site9-image]')].indexOf(thumb) + 1;
  image.alt = thumb.dataset.site9Alt;
  root.querySelectorAll('[data-site9-image]').forEach((button) => button.setAttribute('aria-pressed', String(button === thumb)));
});
document.querySelectorAll('[data-site9-product]').forEach((root) => {
  const gallery = root.querySelector('.site9-gallery-main');
  if (gallery.dataset.site9SwipeReady) return;
  gallery.dataset.site9SwipeReady = 'true';
  const hoverImage = gallery.querySelector('.site9-gallery-hover img');
  if (hoverImage) {
    const enableHover = () => {
      if (hoverImage.naturalWidth > 0) gallery.classList.add('site9-hover-ready');
    };
    if (hoverImage.complete) enableHover();
    else hoverImage.addEventListener('load', enableHover, { once: true });
  }
  let startX = 0;
  let startY = 0;
  gallery.addEventListener('touchstart', (event) => {
    startX = event.changedTouches[0].clientX;
    startY = event.changedTouches[0].clientY;
  }, { passive: true });
  gallery.addEventListener('touchend', (event) => {
    const dx = event.changedTouches[0].clientX - startX;
    const dy = event.changedTouches[0].clientY - startY;
    if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
    const thumbs = [...root.querySelectorAll('[data-site9-image]')];
    const current = thumbs.findIndex((thumb) => thumb.getAttribute('aria-pressed') === 'true');
    if (thumbs.length > 1) thumbs[(current + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length].click();
  }, { passive: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anime-site-header"]) return;
  try {
    
document.addEventListener('change', (event) => { if (event.target.matches('[data-site9-country]')) event.target.form.submit(); });
const site9Mobile = window.matchMedia('(max-width: 749px)');
document.querySelectorAll('[data-site9-header]').forEach((header) => {
  if (header.dataset.site9Ready) return;
  header.dataset.site9Ready = 'true';
  const toggle = header.querySelector('[data-site9-menu]');
  const nav = header.querySelector('.site9-nav');
  const setMenu = (open) => {
    header.classList.toggle('site9-menu-open', open);
    toggle.setAttribute('aria-expanded', String(open));
  };
  toggle.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
  nav.addEventListener('click', (event) => { if (event.target.closest('a')) setMenu(false); });
  header.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
      setMenu(false);
      toggle.focus();
    }
  });
  document.addEventListener('click', (event) => { if (!header.contains(event.target)) setMenu(false); });
  site9Mobile.addEventListener('change', () => setMenu(false));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
